import {
  ProfileIcon,
  GroupIcon,
  SWMSIcon,
  ProjectIcon,
  CompanyProfileIcon,
  ChecklistIcon,
  QrCodeIcon,
} from 'components/Icons'
import { useParamountAuth } from 'context/ParamountAuthContext'
import { Roles } from '@paramount-prestart/shared'

const { CompanyAdmin: ROLE_COMPANY_ADMIN, CompanySupervisor: ROLE_COMPANY_SUPERVISOR, CompanyUser: ROLE_COMPANY_USER, SuperUser: ROLE_SUPER_USER } = Roles.ROLES

export const useNavBarItem = () => {
  const { userCompanyId } = useParamountAuth()
  const navItems = [
    {
      page: '/clients',
      name: 'Clients',
      slug: 'clients',
      icon: GroupIcon,
      allowedRoles: [ROLE_SUPER_USER],
    },
    {
      page: `/company/${userCompanyId}/projectsites`,
      name: 'Projects',
      slug: 'projectsites',
      icon: ProjectIcon,
      allowedRoles: [ROLE_COMPANY_ADMIN, ROLE_COMPANY_USER],
    },
    {
      page: `/company/${userCompanyId}/swms-management`,
      name: 'SWMS',
      slug: 'swms-management',
      icon: SWMSIcon,
      allowedRoles: [ROLE_COMPANY_ADMIN, ROLE_COMPANY_USER],
    },
    {
      page: `/company/${userCompanyId}/checklists`,
      name: 'Checklists',
      slug: 'checklists',
      icon: ChecklistIcon,
      allowedRoles: [ROLE_COMPANY_ADMIN, ROLE_COMPANY_USER],
      showBadge: true,
    },
    {
      page: `/company/${userCompanyId}/my-tradies`,
      name: 'My Tradies',
      slug: 'my-tradies',
      icon: GroupIcon,
      allowedRoles: [ROLE_COMPANY_ADMIN, ROLE_COMPANY_USER],
    },
    {
      page: '/profile',
      name: 'My Profile',
      slug: 'profile',
      icon: ProfileIcon,
      allowedRoles: [
        ROLE_COMPANY_ADMIN,
        ROLE_COMPANY_USER,
        ROLE_COMPANY_SUPERVISOR,
        ROLE_SUPER_USER,
      ],
    },
    {
      page: `/company/${userCompanyId}`,
      name: 'Company Profile',
      slug: 'companyProfile',
      icon: CompanyProfileIcon,
      allowedRoles: [ROLE_COMPANY_ADMIN, ROLE_COMPANY_USER],
    },
    {
      page: '/clients/pending',
      name: 'Pending Registrations',
      slug: 'pending',
      icon: GroupIcon, 
      allowedRoles: [ROLE_SUPER_USER],
      showBadge: true
    },
    {
      page: '/qr-print-requests',
      name: 'QR Print Requests',
      slug: 'qrPrintRequests',
      icon: QrCodeIcon,
      allowedRoles: [ROLE_SUPER_USER],
      showBadge: true,
    },
    {
      page: '/swms-templates',
      name: 'SWMS Templates',
      slug: 'swms-templates',
      icon: SWMSIcon,
      allowedRoles: [ROLE_SUPER_USER],
    },
  ]
  return navItems
}
